import { useInitSetup } from "@/providers/InitSetupProvider";
import { USER_TYPE } from "@/types/enum";
import { useMemo } from "react";

/**
 * Permission rules for learner notes sections:
 *
 * 「所属機関様への報告」
 *   RSO          → visible + editable
 *   Support      → visible + read-only
 *   Company      → hidden
 *
 * 「メモ」(title depends on role)
 *   RSO          → 「登録支援機関内メモ」 visible + editable
 *   Support      → hidden
 *   Company      → 「社内メモ」 visible + editable
 */
export const useLearnerNotesPermission = () => {
  const { userType, isLoading } = useInitSetup();

  const isRSO = !isLoading && userType === USER_TYPE.RSO_USER;
  const isCompany = !isLoading && userType === USER_TYPE.COMPANY_USER;
  const isSupport = !isLoading && userType === USER_TYPE.SUPPORT_USER;

  return useMemo(() => ({
    companyReport: {
      visible: isSupport || isRSO,
      editable: isRSO,
    },
    memo: {
      visible: isRSO || isCompany,
      editable: isRSO || isCompany,
      title: isCompany ? "社内メモ" : "登録支援機関内メモ",
      subtitle: isCompany ? undefined : "登録支援機関の監督メモ（所属機関は閲覧不可）",
    },
  }), [isRSO, isCompany, isSupport]);
};
